import { Dispatch, SetStateAction, createContext } from "react";

export const DateFilterContext = createContext<null | {
  dateRange: [number, number];
  activeDateRange: [number, number];
  setActiveDateRange: Dispatch<SetStateAction<[number, number]>>;
  resetActiveDateRange: () => void;
}>(null);
